import React from 'react';
import { Box, Skeleton } from '@mui/material';

function PerformanceSkeleton() {
    return (
        <Box>
            <Box className="margin-tb-20">
                <Skeleton variant="rounded" width={310} height={45} />
            </Box>
            <Box className="pb-20px">
                <Skeleton variant="rounded" height={350} />
            </Box>
        </Box>
    );
}

export default PerformanceSkeleton;
